import React, { useState } from 'react';
import { Send, Users } from 'lucide-react';

const MessagingWidget = ({ userRole }) => {
  const [recipient, setRecipient] = useState('');
  const [message, setMessage] = useState('');

  const handleSend = () => {
    if (!recipient || !message) {
      alert('Please fill all fields');
      return;
    }
    alert('Message sent successfully!');
    setRecipient('');
    setMessage('');
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Send To</label>
        <select
          value={recipient}
          onChange={(e) => setRecipient(e.target.value)}
          className="w-full px-3 py-2 border rounded-lg"
        >
          <option value="">Select recipient</option>
          <option value="all-students">All Students</option>
          <option value="division">Specific Division</option>
          <option value="batch">Specific Batch</option>
          <option value="individual">Individual Student</option>
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type your message..."
          className="w-full px-3 py-2 border rounded-lg"
          rows={4}
        />
      </div>

      <button
        onClick={handleSend}
        className="w-full flex items-center justify-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
      >
        <Send className="w-4 h-4" />
        <span>Send Message</span>
      </button>
    </div>
  );
};

export default MessagingWidget;